import { combineReducers } from 'redux';
import traveller from '../pages/travellersDetails/store/reducers/TravellerReducer';
import listing from '../pages/listing/listingStore/ListingReducer';
import thankYou from '../pages/thankYou/reducer/ThankyouReducer';
import user from '../pages/travellersDetails/store/reducers/UserReducer';
import landing from './reducers/LandingReducer';
import login from './reducers/LoginReducer';
import newAccount from '../pages/travellersDetails/store/reducers/NewAccountReducer';
import abConfig from "./reducers/AbConfigReducer";

export default combineReducers({
  listing,
  traveller,
  thankYou,
  user,
  landing,
  login,
  newAccount,
  abConfig,
});
